import { create } from 'zustand'
import apiCompanyUsers from '../features/configuration/services/companyUser'
import { convertKeysToSnakeCase } from '../utils/stringUtilities'


export const usePermissionsStore = create((set, get) => ({
  permissions: null,
  loaded: false,
  loading: false,

  ensureLoaded: async () => {
    const { loaded, loading } = get()
    if (loaded || loading) return
    set({ loading: true })
    try {
      const  data  = await apiCompanyUsers.getPermissions()
      set({
        permissions: convertKeysToSnakeCase(data.permissions) ,
        loaded: true,
        loading: false
      })
    } catch (err) {
      set({ loading: false })
      throw err
    }
  },

  resetPermissions: () =>
    set({ permissions: null, loaded: false, loading: false }),

  hasPermission: (permission) => {
    const mapper = permission.split(':')[0]
    return get().permissions?.[mapper]?.includes(permission)
  }
}))
